// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';

// Explicit store the dispatch()
// TODO: Need to find a way to access store in helper functions
const store = {};

const setStore = value => {
  store.dispatch = value;
};

const getDecodeToken = token => {
  let tokenInQuestion = token;
  if (!tokenInQuestion) {
    tokenInQuestion = JSON.parse(sessionStorage.getItem('accessToken')).token;
  }
  return jwt_decode(tokenInQuestion);
};

const getStore = () => {
  return store;
};

/**
 * Checks if the hostname is a development environment
 * @param {string} hostname The hostname, e.g. multi-corp-qa.vulog.center
 * @returns {bool}
 */
const isDevPlatform = hostname => Boolean(hostname && ['localhost', '127.0.0.1'].includes(hostname));

/**
 * Returns the hostname of the selected client
 * @returns {string} hostname
 */
const getHostname = () => {
  if (!isDevPlatform(window.location.hostname)) {
    return window.location.hostname;
  }

  const selectedHost = sessionStorage.getItem('selectedHost');
  if (selectedHost) {
    return selectedHost;
  }

  return '';
};

const getRootPath = () => {
  const hostname = getHostname();
  return `https://${hostname}/fe-api/anonymous/bbo/${hostname}`;
};

/**
 * @param {string} businessId The business id
 * @param {boolean} isAdmin If the user is Admin or not. It's used to avoid calling again localStorage.getItem.
 * @returns {string} The role of the user
 */
const getRoles = (businessId, isAdmin = null) => {
  if (isAdmin === null) {
    const role = localStorage.getItem('role');
    if (role === 'admin') {
      return 'admin';
    }
  } else if (isAdmin) {
    return 'admin';
  }

  let permission = localStorage.getItem('businessRole');
  if (permission) {
    permission = JSON.parse(permission);
  }
  let result = 'customer';
  if (permission) {
    if (!businessId) {
      Object.keys(permission).forEach(entityId => {
        if (permission[entityId].includes('BUSINESS_OWNER')) {
          result = 'owner';
        } else if (permission[entityId].includes('BUSINESS_DELEGATED_ADMIN')) {
          result = 'delegated admin';
        }
      });
    } else {
      const roleuser = permission[businessId];
      if (roleuser !== undefined) {
        if (roleuser.includes('BUSINESS_OWNER')) {
          result = 'owner';
        } else if (roleuser.includes('BUSINESS_DELEGATED_ADMIN')) {
          result = 'delegated admin';
        }
      }
    }
  }
  return result;
};

const index = (obj, is) => {
  const objLoc = obj;
  if (typeof is === 'string') {
    return index(objLoc, is.split('.'));
  }
  if (is.length === 0) {
    return objLoc;
  }
  return index(objLoc[is[0]], is.slice(1));
};

// TODO: This is an ugly way to pass custom parameters to data provider.
// See this unanswered question for reference: https://stackoverflow.com/questions/52931221/passe-custom-query-params-to-show-and-get-one
let params = {};
const setParameters = p => {
  params = { ...params, ...p };
};
const getParameters = () => params;

// Handle axios error
const error = err => {
  let result = '';
  if (err.code === 'ECONNABORTED') {
    result = 'error.requestTimeOut';
  } else if (err.response) {
    const { data } = err.response;
    if (data && data.errorCode) {
      result = JSON.stringify(data);
    }
    // handle here the case in which there's no contact information
    else if (data && data.invalid_reason) {
      result = err.response.data.invalid_reason;
    } else result = `error.${err.response.status}`;
  } else if (err.request) {
    result = 'error.network';
  } else {
    result = err.message;
  }
  return result;
};

// This function travels deeply into a model and add missing id (generate randomly) to any objects/sub-objects found
const deepAssignId = m => {
  const model = m;
  if (model instanceof Array) {
    model.forEach((item, i, originArr) => {
      const arr = originArr;
      arr[i] = deepAssignId(item);
    });
  } else if (model instanceof Object) {
    Object.keys(model).forEach(propName => {
      const prop = model[propName];
      if (prop instanceof Array) {
        prop.forEach((item, i, originArr) => {
          const arr = originArr;
          arr[i] = deepAssignId(item);
        });
      } else if (prop instanceof Object) {
        model[propName] = deepAssignId(prop);
      }
    });
    if (!model.id) {
      model.id = `autoid_${Math.ceil(Math.random() * 0xffffffff)}_${Math.ceil(Math.random() * 0xffffffff)}`;
    }
  }
  return model;
};

// This function travels deeply into a model and remove auto-generated id
const deepUnassignId = m => {
  const model = m;
  if (model instanceof Array) {
    model.forEach((item, i, originArr) => {
      const arr = originArr;
      arr[i] = deepUnassignId(item);
    });
  } else if (model instanceof Object) {
    Object.keys(model).forEach(propName => {
      const prop = model[propName];
      if (prop instanceof Array) {
        prop.forEach((item, i, originArr) => {
          const arr = originArr;
          arr[i] = deepUnassignId(item);
        });
      } else if (prop instanceof Object) {
        model[propName] = deepUnassignId(prop);
      }
    });
    if (
      model.id &&
      Object.prototype.toString.call(model.id) === '[object String]' &&
      model.id.indexOf('autoid_') >= 0
    ) {
      delete model.id;
    }
  }
  return model;
};
let countShowLoad = 0;
const showLoadingScreen = isShow => {
  const loadingdata = document.getElementById('loadingdata');
  if (loadingdata) {
    countShowLoad += isShow ? 1 : -1;
    loadingdata.style.display = !isShow && countShowLoad === 0 ? 'none' : 'table';
  }
};
const hiddenLoadingScreen = () => {
  const loadingdata = document.getElementById('loadingdata');
  if (loadingdata) {
    loadingdata.style.display = 'none';
  }
};

const getCurrentUserDataLogged = () => {
  const { token } = JSON.parse(sessionStorage.getItem('accessToken'));
  return token && getDecodeToken(token);
};

const getArrayDiff = (basicArray, alteredArray) => {
  const added = alteredArray.filter(alteredArrayElement => !basicArray.includes(alteredArrayElement));
  const removed = basicArray.filter(basicArrayElement => !alteredArray.includes(basicArrayElement));
  return [added, removed];
};

const maskIban = [
  /[a-zA-Z]/,
  /[a-zA-Z]/,
  /\d/,
  /\d/,
  ' ',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
];

const utils = {
  showLoadingScreen,
  hiddenLoadingScreen,
  deepAssignId,
  deepUnassignId,
  getHostname,
  getRootPath,
  getRoles,
  setStore,
  getStore,
  index,
  setParameters,
  getParameters,
  error,
  getDecodeToken,
  maskIban,
  getCurrentUserDataLogged,
  isDevPlatform,
  getArrayDiff,
};

export default utils;
